import { useState, useEffect } from 'react';

const bgImages = [
  "https://storage.readdy-site.link/project_files/87c7b670-e58f-43d0-8b86-641e4392a524/9be4220c-d45f-49f7-94f7-94a8e69d2587_KakaoTalk_20260426_162908167.jpg?v=9a6aaa0f67c8a4488b690062622835ff",
  "https://static.readdy.ai/image/86e003dad094a66c852fef49eb35a632/cb2da44c87d9646a2697915bfbef2015.png",
];

const bgLabels = ["청소 전", "청소 후"];

export default function HeroSection() {
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % bgImages.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        {bgImages.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={bgLabels[idx]}
            className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ${
              idx === currentBg ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20"></div>

        {/* 현재 사진 라벨 */}
        <div className="absolute top-24 right-6 z-20">
          <span className="bg-amber-500/80 text-white text-xs font-semibold px-3 py-1 rounded-full backdrop-blur-sm">
            {bgLabels[currentBg]}
          </span>
        </div>

        {/* 인디케이터 */}
        <div className="absolute bottom-20 right-6 flex gap-2 z-20">
          {bgImages.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentBg(idx)}
              className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                idx === currentBg ? 'bg-amber-400 w-6' : 'bg-white/50 w-2'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 text-amber-300 text-sm font-medium px-4 py-2 rounded-full mb-6">
            <i className="ri-heart-fill"></i>
            <span>가족처럼 정직하게, 공간은 깨끗하게</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
            전문가의 손길로<br />
            <span className="text-amber-400">새집처럼</span> 깨끗하게
          </h1>

          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            퇴실청소, 특수청소, 유품정리 전문 서비스.<br />
            남들이 꺼리는 일을 정직하고 조용하게 해결해드립니다.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="tel:01055608051"
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              <span>전화 상담하기</span>
            </a>
            <button
              onClick={() => scrollTo("services")}
              className="bg-white/10 hover:bg-white/20 border border-white/40 text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <span>서비스 둘러보기</span>
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>

          <div className="flex flex-wrap gap-8">
            {[
              { num: "5,000+", label: "누적 작업 건수" },
              { num: "고객 만족", label: "고객 만족도" },
              { num: "20년", label: "업계 경력" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl font-bold text-amber-400">{stat.num}</div>
                <div className="text-sm text-white/70 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button onClick={() => scrollTo("services")} className="cursor-pointer">
          <i className="ri-arrow-down-s-line text-white/60 text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
